export const positiveInfinity = () => Number.POSITIVE_INFINITY;
export const negativeInfinity = () => Number.NEGATIVE_INFINITY;